import { ImagesLocation } from '../types';

export const PRODUCT_IMAGES_CAROUSEL_VISIBILITY_NAME = 'productImagesCarousel';

export interface ProductImagesCarouselImpression {
  event: 'custom_event';
  event_category: 'Image carousel';
  event_action: 'Impression';
  event_label: string;
}

export interface ProductImagesCarouselExpand {
  event: 'custom_event';
  event_action: 'Expand image';
  event_category: 'Image carousel';
  event_label: ImagesLocation;
}

export interface ProductImagesCarouselImageClick {
  event: 'custom_event';
  event_action: 'Image click';
  event_category: 'Image carousel';
  event_label: ImagesLocation;
}

export interface ProductImagesCarouselNavigate {
  event: 'custom_event';
  event_action: 'Next image' | 'Previous image';
  event_category: 'Image carousel';
  event_label: ImagesLocation;
}
